module.exports = __webpack_public_path__ + "media/images/sandbox/pad_opt-57a1f84e69a8ac68826453177c9a364e.png";